import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

// attach bearer fallback (some browsers block third-party cookies)
api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("trawell_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});
